import { isEqual } from "./parse";

export const getUserSavePermission = ({id, addPermission = false, editPermission = false}) => {
  if (isEqual(id, "add")) return addPermission;
  return editPermission;
};
